import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Input, Modal } from "ui";

import {
  useInternalBankReplenish,
  useInternalBankReplenishmentUpdate
} from "../../../apis";
import { ReplenishInternalBankModalProps } from "./ReplenishInternalBankModal.types";

const ReplenishInternalBankModal = ({
  editableItem,
  isOpen,
  onClose
}: ReplenishInternalBankModalProps) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<string>(
    editableItem?.amount ? String(editableItem?.amount) : ""
  );

  const replenishInternalBank = useInternalBankReplenish({
    onSuccess: () => {
      toast.success(t("Internal bank replenished successfully"));
      onClose?.();
    }
  });

  const updateInternalBank = useInternalBankReplenishmentUpdate({
    onSuccess: () => {
      toast.success(t("Internal bank replenishment updated successfully"));
      onClose?.();
    }
  });

  const onSubmit = () => {
    if (editableItem) {
      updateInternalBank.mutate({
        id: editableItem.id,
        amount: Number(amount)
      });
    } else {
      replenishInternalBank.mutate({ amount: Number(amount) });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title={
        editableItem
          ? "Edit Internal Bank Replenishment"
          : "Internal Bank Replenish"
      }
      okText={editableItem ? "Edit" : "Replenish"}
      isLoading={
        replenishInternalBank.isLoading || updateInternalBank.isLoading
      }
      onOk={onSubmit}
      onClose={onClose}
    >
      <Input
        type="number"
        label="Amount"
        placeholder="Enter the Amount of Replenishment"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
      />
    </Modal>
  );
};

export default ReplenishInternalBankModal;
